import { postPublicChatBot } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const sendContactUsMessage = async (payload) => {
  const builder = new UrlBuilder(`/general/send-inquiry`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
